import {BRAND_URL_PARAM} from "./BrandContext";

/** A slug as the backend allows one (SlugService.VALID). */
const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * The brand a payment link names, or null for a plain link.
 *
 * A link names its brand by path — `pay.nflp.com/vista` — and the backend answers that path with
 * this same page (BrandPageFilter). The site's own files live under PUBLIC_URL, so a path there is
 * read past that prefix: the CRA dev server serves the app only under it, which makes
 * `/payment-app/vista` the local form of the same link.
 *
 * Links from before brands moved into the path named them as `?brand=`, which is still honoured.
 */
export function brandSlugFromUrl(pathname: string,
                                 search: string,
                                 publicUrl: string = process.env.PUBLIC_URL || ""): string | null {
    const segments = pathname.split("/").filter(segment => segment.length > 0);
    const prefix = publicUrl.replace(/^\/+|\/+$/g, "");
    if (prefix && segments[0] === prefix) segments.shift();

    if (segments.length === 1) {
        // Case-insensitive like the backend's lookup, so a hand-typed /Vista still works.
        const slug = segments[0].toLowerCase();
        if (SLUG.test(slug)) return slug;
    }

    const fromQuery = new URLSearchParams(search).get(BRAND_URL_PARAM);
    return fromQuery && fromQuery.trim() ? fromQuery.trim() : null;
}
